import React, { useCallback, useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import PromotionOffersType from './components/add/PromotionOffersType';
import FormSection from 'components/shared/FormSection/index';
import PromotionOffersInformation from './components/add/PromotionOffersInformation';
import { OFFER_TYPE } from './utils/constants';
import { create, getDetail, update } from 'services/promotion-offers.service';
import { buildPromotionOfferPayload, promotionOfferDefaults } from './utils/promotionOfferForm';
import FormStatus from 'components/shared/FormCommon/FormStatus';
import { useParams, useLocation } from 'react-router-dom';
import { showToast } from 'utils/helpers';
import styled from 'styled-components';
import { normalizePromotionGiftRows } from './utils/promotionGiftQuantity';
// import PromotionReview from './components/add/PromotionReview';

const PromotionOffersFormLayout = styled.div`
  @media (min-width: 769px) {
    height: calc(100dvh - 51px);
    min-height: 0;
    overflow: hidden;

    > form {
      display: flex;
      flex-direction: column;
      height: 100%;
      min-height: 0;
    }

    > form > .bw_main_wrapp {
      flex: 1 1 0;
      min-height: 0;
      overflow-y: auto;
      overscroll-behavior: contain;
      scrollbar-gutter: stable;
    }

    &&& > form > .bw_form_section_actions.bw_btn_save {
      position: static !important;
      flex: 0 0 auto;
      margin: 8px 16px 12px auto !important;
    }
  }
`;

const PromotionOffersAddPage = () => {
  const { promotion_offers_id } = useParams();
  const { pathname } = useLocation();
  const disabled = React.useMemo(() => pathname.includes('/detail'), [pathname]);
  const methods = useForm({
    defaultValues: promotionOfferDefaults,
  });
  const detailForm = [
    {
      id: 'information_detail',
      title: 'Thông tin ưu đãi khuyến mại',
      component: PromotionOffersInformation,
    },
    {
      id: 'offer_type_detail',
      title: 'Ưu đãi khuyến mại',
      component: PromotionOffersType,
    },
    {
      id: 'form_status',
      title: 'Trạng thái',
      component: FormStatus,
    },
  ];

  const onSubmit = async (values) => {
    try {
      const payload = buildPromotionOfferPayload(values);
      payload.list_offer_gifts = normalizePromotionGiftRows(payload.list_offer_gifts);
      if (payload.offer_type === OFFER_TYPE.GIFT && !payload.list_offer_gifts?.length) {
        showToast.warning('Vui lòng chọn ít nhất một sản phẩm quà tặng.');
        return;
      }

      let label;
      if (promotion_offers_id) {
        await update(promotion_offers_id, payload);
        label = 'Chỉnh sửa';
      } else {
        await create(payload);
        label = 'Thêm mới';
        methods.reset(promotionOfferDefaults);
      }
      showToast.success(`${label} thành công`);
    } catch (error) {
      showToast.error(error?.message ?? 'Có lỗi xảy ra');
    }
  };

  const loadData = useCallback(() => {
    if (promotion_offers_id)
      getDetail(promotion_offers_id).then((o) => {
        let offer_type;
        if (o?.is_discount_by_set_price) {
          offer_type = OFFER_TYPE.DIRECT;
          delete o?.is_discount_by_set_price;
        } else if (o?.is_fix_price) {
          offer_type = OFFER_TYPE.HARD;
          delete o?.is_fix_price;
        } else if (o?.is_fixed_gift) {
          offer_type = OFFER_TYPE.GIFT;
          delete o?.is_fixed_gift;
        } else if (o?.is_percent_discount) {
          offer_type = OFFER_TYPE.PERCENT;
          delete o?.is_percent_discount;
        } else if (o?.is_transport) {
          offer_type = OFFER_TYPE.TRANSPORT;
        } else if (o?.is_payment_form) {
          offer_type = OFFER_TYPE.ISPAYMENTFORM;
        }
        methods.reset({
          ...o,
          offer_type,
        });
      });
  }, [promotion_offers_id]);
  useEffect(loadData, [loadData]);

  return (
    <FormProvider {...methods}>
      <PromotionOffersFormLayout>
        <FormSection disabled={disabled} detailForm={detailForm} onSubmit={onSubmit} />
      </PromotionOffersFormLayout>
    </FormProvider>
  );
};

export default PromotionOffersAddPage;
